import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {AuthenticationServiceService} from '../../../authentication/service/authentication-service.service';
import {ToastrService} from 'ngx-toastr';
import {FirmwareService} from '../../service/firmware.service';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-firmware-form',
  templateUrl: './firmware-form.component.html',
  styleUrls: ['./firmware-form.component.css']
})
export class FirmwareFormComponent implements OnInit {
  firmwareDetailForm: FormGroup;
  selectedFiles: FileList;
  loading: boolean;
  submitted: boolean;
  firmwareStatusList: any;
  constructor(private _formBuilder: FormBuilder,
              private router: Router,
              private firmwareService: FirmwareService,
              private toastr: ToastrService) {
    this.firmwareDetailForm = this._formBuilder.group({
      firmwareType: ['', Validators.required],
      versionNumber: ['001'],
      versionName: ['', Validators.required],
      versionStatus: ['', Validators.required],
      firmwareFile: ['', Validators.required],
      releaseNote: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.getAllFirmwareStatus();
  }

  public getAllFirmwareStatus() {
    this.firmwareStatusList = [
      { displayName: 'Latest', value: 'LATEST' },
      { displayName: 'Stable', value: 'STABLE' },
      { displayName: 'Released', value: 'RELEASED' },
      { displayName: 'Beta', value: 'BETA' },
      { displayName: 'Reverted', value: 'REVERTED'}
    ];
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  firmwareTypeChanged() {
    if (this.firmwareDetailForm.value.firmwareType === 'APPLICATION') {
      this.firmwareDetailForm.controls['versionName'].setValue('LPC_WMM_');
    } else if ( this.firmwareDetailForm.value.firmwareType === 'OTA') {
      this.firmwareDetailForm.controls['versionName'].setValue('LPC_OTA_');
    }

  }

  saveFirmware(firmwareDetailsForm) {

    const formdata: FormData = new FormData();
    console.log(this.selectedFiles.item(0));
    formdata.append('firmwareFile', this.selectedFiles.item(0));
    formdata.append('firmwareType',  this.firmwareDetailForm.value.firmwareType);
    formdata.append('versionNumber',  this.firmwareDetailForm.value.versionNumber);
    formdata.append('versionName',  this.firmwareDetailForm.value.versionName);
    formdata.append('versionStatus',  this.firmwareDetailForm.value.versionStatus);
    formdata.append('releaseNote',  this.firmwareDetailForm.value.releaseNote);

    this.firmwareService.addFirmware(formdata)
      .pipe(first())
      .subscribe(data => {
        if (data.status === 200) {
          this.toastr.success('', 'Auth Details saved successfully');
          this.router.navigate(['/elasticcare/firmware']);
          this.loading = false;
        } else {
          this.toastr.error('', 'Please try again');
        }
      }, (error) => {
        this.toastr.error('', 'Please try again');
        this.loading = false;
      });
  }
}
